import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  max-width: 360px;
  h3 {
    margin-bottom: 1rem;
  }
  button {
    margin-top: 1rem;
  }
`;
